import(/* webpackMode: "eager" */ "/codebuild/output/src3540671299/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/capital_manager/page.tsx");
